import { render, staticRenderFns } from "./WordWheel.vue?vue&type=template&id=d2f26d36"
import script from "./WordWheel.vue?vue&type=script&lang=js"
export * from "./WordWheel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports